import { useEffect, useState } from "react";
import FetchError from "../interface/FetchError";
import { AxiosResponse } from "axios";
import apiService from "../services/api.service";

interface SolutionImage {
  id: number;
  image: string;
}

interface Solution {
  id: number;
  exercise_type: string;
  exercise_number: string;
  answer: string;
  solution_images: SolutionImage[];
}

interface Chapter {
  id: number;
  title: string;
}

const groupSortAndFlattenSolutions = (solutions: Solution[]): Solution[] => {
  const groupedSolutions = solutions.reduce((acc, solution) => {
    if (!acc[solution.exercise_type]) {
      acc[solution.exercise_type] = [];
    }
    acc[solution.exercise_type].push(solution);
    return acc;
  }, {} as Record<string, Solution[]>);

  const sortedGroupedSolutions = Object.keys(groupedSolutions).map((status) => {
    return groupedSolutions[status].sort((a, b) =>
      a.exercise_number.localeCompare(b.exercise_number)
    );
  });

  return sortedGroupedSolutions.flat();
};

const adminUseFetchChapterSolutions = (chapterId: string) => {
  const [solutions, setSolutions] = useState<Solution[]>([]);
  const [chapter, setChapter] = useState<Chapter | null>(null);
  const [error, setError] = useState<FetchError>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [solutionResponse, chapterResponse] = await Promise.all([
          apiService.get<AxiosResponse>(`/solutions/?chapter_id=${chapterId}`),
          apiService.get<AxiosResponse>(`/chapters/?chapter_id=${chapterId}`),
        ]);

        const sortedSolutions = groupSortAndFlattenSolutions(
          solutionResponse.data
        );
        setSolutions(sortedSolutions);
        setChapter(chapterResponse.data[0]);
      } catch (error) {
        if (error instanceof Error) {
          setError(error);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [chapterId]);

  return { solutions, chapter, loading, error };
};

export default adminUseFetchChapterSolutions;
